// Sin modificar número original. Sólo se parsea para mejor legibilidad.
export function formatPhone(phone: string | number): string {
  const raw = String(phone).replace(/\D/g, ''); // Solo números

  // +549XXXXXXXXXX(10) => +54 9 XX XXXX XXXX
  if (raw.length === 13 && raw.startsWith('549')) {
    return `+54 9 ${raw.slice(3, 5)} ${raw.slice(5, 9)} ${raw.slice(9)}`;
  }

  // +54XXXXXXXXXX(10) => +54 XX XXXX XXXX
  if (raw.length === 12 && raw.startsWith('54')) {
    return `+54 ${raw.slice(2, 4)} ${raw.slice(4, 8)} ${raw.slice(8)}`;
  }

  // 011XXXXXXXXX (9) => 011 XXXX XXXX
  if (raw.length === 11 && raw.startsWith('011')) {
    return `011 ${raw.slice(3, 7)} ${raw.slice(7)}`;
  }

  // 01115XXXXXXXX(8) => 011 XXXX XXXX
  if (raw.length === 13 && raw.startsWith('01115')) {
    return `011 ${raw.slice(5, 9)} ${raw.slice(9, 13)}`;
  }

  // 11XXXXXXXX(8) => 11 XXXX XXXX
  if (raw.length === 10 && raw.startsWith('11')) {
    return `${raw.slice(0, 2)} ${raw.slice(2, 6)} ${raw.slice(6)}`;
  }

  // 370XXXXXXX(7) => 370 XXX XXXX (códigos de área de 3 dígitos)
  if (raw.length === 10 && /^[2-3]\d{2}/.test(raw)) {
    return `${raw.slice(0, 3)} ${raw.slice(3, 6)} ${raw.slice(6)}`;
  }

  // XXXXXXXX(8) => XXXX XXXX
  if (raw.length === 8) {
    return `${raw.slice(0, 4)} ${raw.slice(4)}`;
  }

  return phone.toString();
}
